import { Tooltip } from "@mui/material";

export default function CommonToolTip({ title, children }) {
  return <Tooltip title={title}>{children}</Tooltip>;
}
